<!-- AUTOCOMPLETE -->
<div class="position-relative" [hidden]="isManualInput">
  <mat-form-field class="pb-0 w-100" (keyup)="checkLatin('addressControl',$event)">
    <mat-label *ngIf="placeholder.trim().length > 0"
      class="text-black subtitle_1">{{ placeholder | translate }}</mat-label>
    <input #addressText (change)="onChange($event)" [formControl]="addressControl" class="text_3" matInput type="text">
    <mat-error class="minitext_2">
      <span *ngIf="addressControl.hasError('required')">{{ "COMMON.IS_REQUIRED" | translate }}</span>
      <span
        *ngIf="addressControl.hasError('notPicked') && (!pickedAddress || !pickedAddress.country) && !isFetchingData">{{ "COMMON.AUTOCOMPLETE_ERROR" | translate }}</span>
      <span *ngIf="addressControl.hasError('latin')">{{ "COMMON.ONLY_LATIN_ERROR" | translate }}</span>

    </mat-error>
  </mat-form-field>

  <span *ngIf="isFetchingData" class="spinner-border spinner-border-sm position-absolute"></span>

  <div class="position-absolute text-success d-flex align-items-center font-12" *ngIf="!isFetchingData && ((pickedAddress && pickedAddress.country) || (addressControl.value && !pickedAddress))">
    <span class="material-icons-outlined font-12 me-1">done</span>
    {{ 'COMMON.OK_CHECKED' | translate }}
  </div>
  <mat-form-field [ngClass]="{'pb-0': showManualInput}" class="pb-0 w-100" (keyup)="checkLatin('address2FormControl',$event)">
    <mat-label class="text-black subtitle_1">{{ 'COMMON.ADDITIONAL_ADDRESS' | translate }}</mat-label>
    <input (change)="onChange2($event)" [formControl]="address2FormControl" class="text_3" matInput type="text">
  </mat-form-field>
</div>

<!-- SWITCH TO MANUAL BUTTON -->
<button type="button" id="autocomplete_address_not_found" (click)="goManual(!isManualInput)" *ngIf="showManualInput"
  class="btn p-0 minitext_2 border-0 lightGray2 mb-4">
  {{ (isManualInput ? 'COMMON.ADDRESS_GO_AUTOCOMPLETE' : 'COMMON.ADDRESS_GO_MANUAL') | translate}}
</button>

<!-- MANUAL FORM -->
<div *ngIf="isManualInput" [ngClass]="{'d-flex flex-column' :manualAddressForm.controls.city_name }">
  <mat-select-country appearance="fill" class="w-100 mb-4" label="{{ 'COMMON.USER.LIVIN_COUNTRY' | translate }}"
    (onCountrySelected)="onCountrySelected($event)"
    *ngIf="predefinedCountries && predefinedCountries.length > 0"
    [countries]="predefinedCountries"
    [formControl]="manualAddressForm.controls.country_obj"></mat-select-country>

  <app-city-input [user]="user" [cityControl]="manualAddressForm.controls.city_name" [floatLabel]="'always'"
                  *ngIf="manualAddressForm.controls.city_name" [labelContent]="'COMMON.USER.LIVIN_CITY' | translate"
                  [wantedField]="'livingPlace'"></app-city-input>

  <mat-form-field *ngIf="manualAddressForm.controls.route" class="pb-0 w-100" (keyup)="checkLatin('route',$event)">
    <mat-label class="text-black subtitle_1">{{ 'COMMON.USER.LIVIN_ADDRESS' | translate }}</mat-label>
    <input [formControl]="manualAddressForm.controls.route" class="text_3" matInput type="text">
    <mat-error class="minitext_2">
      <span *ngIf="manualAddressForm.controls.route.hasError('required')">{{ "COMMON.IS_REQUIRED" | translate }}</span>
    </mat-error>
  </mat-form-field>

  <div>
    <mat-form-field *ngIf="manualAddressForm.controls.additional" class="pb-0 w-100" (keyup)="checkLatin('additional',$event)">
      <mat-label class="text-black subtitle_1">{{ 'COMMON.ADDITIONAL_ADDRESS' | translate }}</mat-label>
      <input [formControl]="manualAddressForm.controls.additional" class="text_3" matInput type="text">
    </mat-form-field>

    <p class="lightGray2 minitext_2">{{ 'COMMON.INVALID_ADDRESS_NOT_RESPONSIBLE' | translate }}</p>
  </div>

</div>
